module.exports = new __parcel__URL__("images/location-circle.02dd86fa.png").toString();